import {
    faAlignLeft,
    faCommentAlt,
    faHardHat,
    faPercentage,
    faSmile,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";

import ModalSubNav from "../../../Modais";
import { IComponentModal } from "../../../Modais/IModalComponent";

import MotivoInadimplencia from "./MotivoInadimplencia";

import ResultadoContato from "./ResultadoContato";

import { useUserInfor } from "../../../../Context/User/";
import { Obras } from "./ObraCobranca";
import { ClassificacaoCobranca } from "./ClassificacaoCobranca";
import { ACESSOS } from "../../../../Routes/Acessos";
import { mostrarNavDeTela } from "../../../../Validations/UsuarioTela";
import { NavLink } from "react-router-dom";

export function SubNavCobrancaGestaoDeCadastros() {
    const [show, setShow] = useState(false);

    const [Modal, SetModal] = useState<IComponentModal>();
    const { UserInfor } = useUserInfor();

    return (
        <>
            {UserInfor.TELAS
                ? UserInfor.TELAS.map((tela) => {
                      if (
                          tela.ID_TELA ===
                          ACESSOS.COBRANCA.MODAIS.MOTIVO_INADIMPLENCIA.ID_TELA
                      ) {
                          return (
                              <li key={tela.ID_TELA} className="menu-item">
                                  <a
                                      href="#/"
                                      className="menu-link"
                                      onClick={() => {
                                          setShow(true);
                                          SetModal({
                                              headerComponent:
                                                  "Motivo Inadimplência",
                                              IconHeader: faCommentAlt,
                                              Component: MotivoInadimplencia,
                                              collapseForm: true,
                                          });
                                      }}
                                  >
                                      <span className="svg-icon menu-icon">
                                          <FontAwesomeIcon
                                              icon={faCommentAlt}
                                          />
                                      </span>
                                      <span className="menu-text">
                                          Motivo Inadimplência
                                      </span>
                                  </a>
                              </li>
                          );
                      } else return <div key={tela.ID_TELA}></div>;
                  })
                : null}

            {UserInfor.TELAS
                ? UserInfor.TELAS.map((tela) => {
                      if (
                          tela.ID_TELA ===
                          ACESSOS.COBRANCA.MODAIS.RESULTADO_CONTATO.ID_TELA
                      ) {
                          return (
                              <li key={tela.ID_TELA} className="menu-item">
                                  <a
                                      href="#/"
                                      className="menu-link"
                                      onClick={() => {
                                          setShow(true);
                                          SetModal({
                                              headerComponent:
                                                  "Resultados Contato",
                                              IconHeader: faSmile,
                                              Component: ResultadoContato,
                                              collapseForm: true,
                                              size: "lg",
                                          });
                                      }}
                                  >
                                      <span className="svg-icon menu-icon">
                                          <FontAwesomeIcon icon={faSmile} />
                                      </span>
                                      <span className="menu-text">
                                          Resultado de Contato
                                      </span>
                                  </a>
                              </li>
                          );
                      } else return <div key={tela.ID_TELA}></div>;
                  })
                : null}

            {UserInfor.TELAS
                ? UserInfor.TELAS.map((tela) => {
                      if (
                          tela.ID_TELA ===
                          ACESSOS.COBRANCA.MODAIS.OBRA_COBRANCA.ID_TELA
                      ) {
                          return (
                              <li key={tela.ID_TELA} className="menu-item">
                                  <a
                                      href="#/"
                                      className="menu-link"
                                      onClick={() => {
                                          setShow(true);
                                          SetModal({
                                              headerComponent: "Obra Cobrança",
                                              IconHeader: faHardHat,
                                              Component: Obras,
                                              collapseForm: true,
                                              size: "xl",
                                          });
                                      }}
                                  >
                                      <span className="svg-icon menu-icon">
                                          <FontAwesomeIcon icon={faHardHat} />
                                      </span>
                                      <span className="menu-text">
                                          Obra Cobrança
                                      </span>
                                  </a>
                              </li>
                          );
                      } else return <div key={tela.ID_TELA}></div>;
                  })
                : null}

            {UserInfor.TELAS
                ? UserInfor.TELAS.map((tela) => {
                      if (
                          tela.ID_TELA ===
                          ACESSOS.COBRANCA.MODAIS.CLASSIFICACAO_COBRANCA.ID_TELA
                      ) {
                          return (
                              <li key={tela.ID_TELA} className="menu-item">
                                  <a
                                      href="#/"
                                      className="menu-link"
                                      onClick={() => {
                                          setShow(true);
                                          SetModal({
                                              headerComponent:
                                                  "Classificação Cobrança",
                                              IconHeader: faAlignLeft,
                                              Component: ClassificacaoCobranca,
                                              size: "lg",
                                          });
                                      }}
                                  >
                                      <span className="svg-icon menu-icon">
                                          <FontAwesomeIcon icon={faAlignLeft} />
                                      </span>
                                      <span className="menu-text">
                                          Classificação Cobrança
                                      </span>
                                  </a>
                              </li>
                          );
                      } else return <div key={tela.ID_TELA}></div>;
                  })
                : null}

            {mostrarNavDeTela(
                ACESSOS.COBRANCA.TELAS.ALCADA_DESCONTO.ID_TELA,
                UserInfor.TELAS
            ) && (
                <li className="menu-item">
                    <NavLink
                        to={ACESSOS.COBRANCA.TELAS.ALCADA_DESCONTO.DS_PATH}
                        className="menu-link"
                    >
                        <span className="svg-icon menu-icon">
                            <FontAwesomeIcon icon={faPercentage} />
                        </span>
                        <span className="menu-text">Desconto de Alçada</span>
                    </NavLink>
                </li>
            )}

            <ModalSubNav show={show} setShow={setShow} ModalComponent={Modal} />
        </>
    );
}
